import { render } from "./FattureAcquistoDataTable.vue?vue&type=template&id=1d3215f2&scoped=true"
import script from "./FattureAcquistoDataTable.vue?vue&type=script&lang=js"
export * from "./FattureAcquistoDataTable.vue?vue&type=script&lang=js"

import "./FattureAcquistoDataTable.vue?vue&type=style&index=0&id=1d3215f2&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3215f2"]])

export default __exports__